import { FileItem } from 'ng2-file-upload';
import { ClearanceItemService } from '../clearance-item.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalService } from '../../shared/helper-components/modal/_services/modal.service';
import { Subject } from 'rxjs/Subject';
import { CIAsset } from '../clearance-item.model';
import { IAssetProcessing } from "./asset-processing.interface";
import { AppService } from "../../app.service";

@Injectable()
export class AssetDocumentProcessing implements IAssetProcessing {


    // private _source = new Subject<string>();
    private _downloadFinished = new Subject<any>();
    private _downloadStarted = new Subject<boolean>();

    // sourceChanged = this._source.asObservable();
    onDownloadStarted = this._downloadStarted.asObservable();
    onDownloadFinished = this._downloadFinished.asObservable();

    constructor(private _appService: AppService, private sanitizer: DomSanitizer) { }

    assetType(): string {
        return 'document';
    }

    downloadAsset(asset:CIAsset, projectId: string, ownerType: string, direct: boolean = false, tryViewInBrowser: boolean = false) {
        this._downloadStarted.next(true);
        if (tryViewInBrowser){
            this._appService.getSignedUrlInline(encodeURIComponent(asset.url), projectId, 'GET', 'document', ownerType, encodeURIComponent(asset.name))
            .subscribe(signedUrl => {
                console.log('ImageProcessing.downloadAsset >> signed Url:' + signedUrl.url);
                let downloadedAsset = Object.assign(new CIAsset(), asset);
                downloadedAsset.name = asset.name;
                downloadedAsset.fullUrl = signedUrl.url;
                
                this._downloadFinished.next({asset: downloadedAsset, direct: direct});
            });    
        }
        else{
            this._appService.getSignedUrl(encodeURIComponent(asset.url), projectId, 'GET', 'document', ownerType, encodeURIComponent(asset.name))
            .subscribe(signedUrl => {
                console.log('ImageProcessing.downloadAsset >> signed Url:' + signedUrl.url);
                let downloadedAsset = Object.assign(new CIAsset(), asset);
                downloadedAsset.name = asset.name;
                downloadedAsset.fullUrl = signedUrl.url;
                
                this._downloadFinished.next({asset: downloadedAsset, direct: direct});
            });
        }
    }

    processAsset(fileItem: FileItem, projectId: string, ownerType:string): Observable<CIAsset> {
        
        //get the signed url to upload to aws
        return this._appService.getSignedUrl(encodeURIComponent(fileItem.file.name), projectId, 'PUT', 'document', ownerType,'')
            .map(signedUrl => {

                console.log('DocumentProcessing.processAsset >> signed Url:' + signedUrl.url);

                let file = fileItem.file;

                let newAsset = new CIAsset();
                newAsset.name = file.name;
                newAsset.urlName = signedUrl.name;
                newAsset.id = signedUrl.name;
                //newAsset.fullUrl = thumbNail
                newAsset.fileType = (file.type === "" ? "application/octet-stream" : file.type);

                //prepare the file to upload
                fileItem.file.name = signedUrl.name;  //set the signed name to the just-added file
                fileItem.url = signedUrl.url.toString()
                fileItem.method = "PUT";

                //notify the listeners that this asset has been added to the loader queue
                return newAsset;
            });

    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/clearance-item/asset-management/asset-document-processing.service.ts